var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-icon-background",style:(`
    width: ${_vm.width};
    height: ${_vm.width};
    padding: calc(${_vm.width} * 0.13);
    border-radius: calc(${_vm.width} * 0.07);
    `)},[_c('div',{staticClass:"ai-icon-wrapper"},[_c('div',{class:`ai-icon-beam ai-icon-beam-1 ${_vm.animation?'ai-icon-beam-1-animation':''}`,style:(_vm.color?`background-color: ${_vm.color}`:'')}),_c('div',{class:`ai-icon-beam ai-icon-beam-2 ${_vm.animation?'ai-icon-beam-2-animation':''}`,style:(_vm.color?`background-color: ${_vm.color}`:'')}),_c('div',{class:`ai-icon-beam ai-icon-beam-3 ${_vm.animation?'ai-icon-beam-3-animation':''}`,style:(_vm.color?`background-color: ${_vm.color}`:'')})])])
}
var staticRenderFns = []

export { render, staticRenderFns }